import React, { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import axios from 'axios';
import * as Raven from 'raven-js';

import * as Api from '../../../weborder/Api';
import * as Data from '../../../weborder/Data';
import { Utilities } from '../../../weborder/Utilities';

interface Props {
  AppConfig: Data.Async<Api.AppConfig>;
  Close: () => any;
  EmailRequestMode: number;
  ShowEmailModal: boolean;
  translate: any;
  UpdateCustomer: () => any;
}

export function EmailModal(props: Props): JSX.Element {
  const {
    AppConfig: appConfig,
    Close: handleClose,
    EmailRequestMode: emailRequestMode,
    ShowEmailModal: showEmailModal,
    translate,
    UpdateCustomer: updateCustomer,
  } = props;

  const [email, setEmail] = useState('');

  const handleEmailChange = (event: any) => {
    setEmail(event.target.value);
  };

  const handleKeyPress = (target: any) => {
    // Handle Enter
    if (target.charCode === 13) {
      handleEmailSubmit();
    }
  };

  const handleDismissModal = () => {
    localStorage.setItem('dismissedModal', 'true');
    handleClose();
  };

  const handleEmailSubmit = () => {
    if (email === '') {
      return;
    }

    const ifSubmitFails = (error: any) => {
      const dataLog: any = {};

      if (appConfig.status === 'success') {
        dataLog.AppNameId = appConfig.data.AppNameId;
        dataLog.WhiteLabelId = appConfig.data.WhiteLabelId;
      }

      Raven.captureMessage('Submit email failed', {
        tags: { category: 'API failure' },
        extra: {
          appconfig: dataLog,
          email: email,
          error: Utilities.handleError(error),
        },
      });
    };

    axios
      .post(
        '/Account/SetEmailAddress',
        { Email: email },
        { withCredentials: true },
      )
      .then((response) => {
        const result: Api.Result<any> = response.data;

        if (!result.Success) {
          // alert(result.UserMessage);
          ifSubmitFails(result);
        } else {
          setEmail('');
          handleClose();
          updateCustomer();
        }
      })
      .catch((error) => {
        const result: Api.Result<any> = error.response.data;

        if (!result.Success) {
          // alert(result.UserMessage);
          ifSubmitFails(result);
        }
      });
  };

  // const offset: string | null = Utilities.extraOption('data-offset');
  const dismissedModal =
    localStorage.getItem('dismissedModal') === 'true' &&
    emailRequestMode === Api.EmailRequestMode.Request;
  let emailModalTitle = null;
  let emailModalButtons = null;

  switch (emailRequestMode) {
    case Api.EmailRequestMode.Require:
      emailModalTitle = translate(
        'We_need_your_email_address_to_process_your_order',
      );
      emailModalButtons = (
        <Button
          disabled={!Utilities.isValidEmail(email)}
          key="submit-button"
          onClick={handleEmailSubmit}
        >
          {translate('Submit')}
        </Button>
      );
      break;
    default:
      emailModalTitle = translate('Please_enter_your_email_address');
      emailModalButtons = (
        <div>
          <Button key="reject-button" onClick={handleDismissModal}>
            {translate('No_thanks')}
          </Button>
          <Button
            disabled={!Utilities.isValidEmail(email)}
            key="submit-button"
            onClick={handleEmailSubmit}
          >
            {translate('Submit')}
          </Button>
        </div>
      );
      break;
  }

  return (
    <Dialog open={showEmailModal && !dismissedModal}>
      <DialogTitle disableTypography tabIndex={0}>
        {emailModalTitle}
      </DialogTitle>

      <DialogContent>
        <input
          aria-label={`${translate('Please_enter_your_email_address')}`}
          autoFocus
          key="email-input"
          onChange={handleEmailChange}
          onKeyPress={handleKeyPress}
          placeholder="Email"
          type="email"
          value={email}
        />
      </DialogContent>

      <DialogActions>{emailModalButtons}</DialogActions>
    </Dialog>
  );
}
